import React from "react";

const InPatient = () => {
  return (
    <div className='main-container'>
      <h1 className='title'>In-Patient Availment</h1>
      <div className='description'>
        How to avail in-patient services:
        <ul id='mainList'>
          <li className='list-item bullet'>
            Member goes to Getwell accredited hospital
          </li>
          <li className='list-item bullet'>
            In the hospital, doctor evaluates members’ condition If for
            admission, Medical staff calls Getwell to verify membership status
          </li>
          <li className='list-item bullet'>
            If membership status is <b>ACTIVE</b>, Admitting section facilitates
            admission and requires Getwell to send or fax the Letter of
            Authorization (LOA) for the coverage If <b>INACTIVE</b>, member is
            declined and advised to call their employer for his/her membership
            status
          </li>
          <li className='list-item bullet '>
            Note: Please double-check room category/plan limit to avoid paying
            incremental costs.
          </li>
          <li className='list-item bullet'>
            Member-patients’ to files PhilHealth Insurance benefits upon
            discharge. [Failure to file, must be charge to patient].
          </li>
          <li className='list-item bullet'>
            Member settles any incremental and miscellaneous charges upon
            discharge
          </li>
        </ul>
      </div>
    </div>
  );
};

export default InPatient;
